import { createApi } from "@reduxjs/toolkit/query/react";
import { getAxiosInstance } from "../../../api";

const axiosBaseQuery =
  () =>
  async ({ params, endpoint, method, body }) => {
    const api = await getAxiosInstance();
    const getParams = (key) => {
      if (params?.[key]) {
        return `${key}=${params[key]}&`;
      } else {
        return "";
      }
    };

    const getQuery = (paramsData) => {
      return getParams(paramsData) !== "" ? `&${getParams(paramsData)}` : "";
    };

    try {
      let url =
        method !== "post"
          ? `${endpoint}?${getParams("sort_by")}sort_order=${
              params?.sort_order || "desc"
            }&length=${params?.length || "10"}&${getParams("search")}page=${
              params?.page || 1
            }${getQuery("franchise_id")}${getQuery("lead_type_id")}${getQuery("start_date")}${getQuery(
              "end_date"
            )}`
          : `${endpoint}`;

      const response = await api[method](url, body);

      if (response?.data?.data?.rows !== undefined) {
        return { data: response?.data?.data };
      } else {
        return { data: response?.data };
      }
    } catch (axiosError) {
      let err = axiosError;

      return {
        data: err?.response?.data || err.message,
      };
    }
  };

export const leads = createApi({
  reducerPath: "leadsApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["Leads"],
  endpoints: (builder) => ({
    getLeadsListData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/v1/lead-data/filters`,
      }),
      providesTags: ["Leads"],
    }),

    updateLeadsListData: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `/v1/table-permission-create`,
      }),
      invalidatesTags: ["Leads"],
    }),
  }),
});

export const { useGetLeadsListDataQuery, useUpdateLeadsListDataMutation } =
  leads;
